import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input, Label } from "../../../components/ui";
import { Textarea } from "../../../components/ui/textarea";
import { recordVendorNotified } from "../api/complianceApi";

const HOW = ["Email", "Letter", "Phone + email", "In person + written"];
const todayISO = () => new Date().toISOString().slice(0, 10);

/** Record that the vendor was told (in writing) about a price change. */
export default function VendorNotifiedDialog({ open, propertyId, priceEvent, onClose, onSaved }) {
  const [how, setHow] = useState(HOW[0]);
  const [at, setAt] = useState(todayISO());
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setHow(HOW[0]); setAt(todayISO()); setNote(""); } }, [open]);
  if (!priceEvent) return null;

  const save = async () => {
    setSaving(true);
    try {
      const res = await recordVendorNotified(propertyId, priceEvent.id, { how, at, note });
      toast.success("Vendor notification recorded");
      onSaved?.(res.data);
      onClose?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not record the notification");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !saving) onClose?.(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Vendor notified</DialogTitle>
          <DialogDescription>{priceEvent.price_kind_label} change. Kept on the compliance audit log.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>How</Label>
            <select className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm" value={how}
              onChange={(e) => setHow(e.target.value)} aria-label="How the vendor was notified">
              {HOW.map((h) => <option key={h} value={h}>{h}</option>)}
            </select>
          </div>
          <div>
            <Label>Date</Label>
            <Input type="date" value={at} onChange={(e) => setAt(e.target.value)} />
          </div>
          <div>
            <Label>Note (optional)</Label>
            <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button onClick={save} disabled={saving}>{saving ? "Saving..." : "Record"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
